import React from "react";
import { Modal } from "antd";
import PrivacyPolicyContent from "./PrivacyPolicyContent";
import "./auths.scss";
import "../modal.scss";

const PrivacyPolicy = (props) => {
  return (
    <Modal
      width="62%"
      className="common-modal common-modal-tc"
      centered
      title={false}
      open={props.visible}
      onOk={props.onClose}
      onCancel={props.onClose}
      footer={""}
      closeIcon={
        <img
          src="/assets/icons/close-icon-circle.svg"
          alt=""
          className="img-fluid"
        />
      }
    >
      <PrivacyPolicyContent />
    </Modal>
  );
};

export default PrivacyPolicy;
